import styled from '@emotion/styled';
import { RouteLink } from 'src/web/components/RouteLink/component';
import {
  OL_COLOUR_BLACK_55,
  OL_COLOUR_NAVY_BABY,
  OL_COLOUR_HIGHLIGHT,
  OL_COLOUR_BLACK_4,
} from 'src/web/components/Style/colours';
import { TextField } from 'src/web/components/TextField/component';

export const NoCourseMatchBlock = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '32px 0',
});

export const NoCourseMatchLabel = styled('span')({
  color: OL_COLOUR_BLACK_55,
  marginBottom: 16,
});

export const FindNewCourseBlock = styled('span')({
  '& a': {
    color: 'black',
  },
});

const ListItem = {
  width: '100%',
  background: 'white',
  border: 'none',
  display: 'flex',
  alignItems: 'center',

  '&:hover': {
    background: OL_COLOUR_HIGHLIGHT,
  },

  '&:focus': {
    boxShadow: 'none',
    background: OL_COLOUR_NAVY_BABY,
    color: 'white',
  },

  '&:focus div': {
    color: 'white',
  },
};

export const CourseBlock = styled('button')({
  ...ListItem,
  padding: 16,
});

export const CohortBlock = styled(RouteLink)({
  ...ListItem,
  color: 'black',
  textDecoration: 'none',
  padding: '16px 16px 16px 32px',
  fontWeight: 'normal',

  '&:hover': {
    color: 'black',
    background: OL_COLOUR_HIGHLIGHT,
  },
});

export const CourseList = styled('div')({
  overflow: 'auto',
});

export const CourseDetails = styled('div')({
  textAlign: 'start',
  flex: 1,
});

export const CourseName = styled('div')({});

export const CourseInstitution = styled('div')({
  marginTop: 5,
  fontSize: 12,
  fontWeight: 600,
  color: OL_COLOUR_BLACK_55,
});

export const StyledTextField = styled(TextField)({
  width: '100%',
});

export const CourseSlug = styled('div')({
  marginTop: 5,
  fontSize: 12,
  color: OL_COLOUR_BLACK_55,
});

export const SearchTextWrapper = styled('div')({
  margin: 16,
});

export const ClearAllIconWrapper = styled('span')(
  ({ hidden }: { hidden: boolean }) => ({
    position: 'absolute',
    marginTop: 5,
    right: 20,
    display: hidden ? 'none' : 'inline',
  })
);

export const LoadingBlock = styled('div')(
  ({ narrow }: { narrow?: boolean }) => ({
    textAlign: 'center',
    paddingTop: narrow ? 16 : 32,
    paddingBottom: narrow ? 16 : 32,
    backgroundColor: OL_COLOUR_BLACK_4,
  })
);

export const CohortContentLoaderWrapper = styled('div')({
  padding: '16px 16px 16px 32px',
});
